<template>
  <v-card :loading="loading" class="elevation-12">
    <template v-if="mail">

      <v-card-actions>
        <template v-if="mail.isSent">
          <v-btn color="primary" text :to="{name: 'track', params: {uid: `EHM${mail.id}`}}">{{ $t('mailPage.protocol', { id: `EHM${mail.id}` }) }}</v-btn>
          <v-btn color="primary" @click="onShowReceiptClicked">{{ $t('mailPage.receipt') }}</v-btn>
        </template>
        <template v-else>
          <v-btn color="primary" :disabled="mail.sendStatus !== null" @click="onSendClicked">{{ $t('mailPage.send') }}</v-btn>

          <div class="font-weight-bold mt-3 ml-5" v-if="mail.sendStatus !== null">
            <p v-if="mail.sendStatus === 0">{{ $t('mailPage.statusPrefix') }}{{ $t('mailPage.statusSending') }}</p>
            <p v-else-if="mail.sendStatus === 2">{{ $t('mailPage.statusPrefix') }}{{ $t('mailPage.statusPostError') }}</p>
            <p v-else-if="mail.sendStatus === 3">{{ $t('mailPage.statusPrefix') }}{{ $t('mailPage.statusPostResponseError') }}</p>
            <p v-else>{{ $t('mailPage.statusPrefix') }}{{ $t('mailPage.statusServerError') }}</p>
          </div>
        </template>
      </v-card-actions>
      <v-divider/>

      <v-card-title>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field v-model="mail.receiver"
                          :label="$t('adminMailsDataTable.filters.receiver')"
                          :disabled="true"
            />
            <v-text-field v-model="mail.address"
                          :label="$t('tableHeaders3.address')"
                          :disabled="true"
            />
            <v-text-field v-model="mail.region.name"
                          :label="$t('adminMailsDataTable.filters.region')"
                          :disabled="true"
            />
            <v-text-field v-model="mail.area.name"
                          :label="$t('adminMailsDataTable.filters.district')"
                          :disabled="true"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="mailCreatedOnStr"
                          :label="$t('adminMailsDataTable.table.creationDate')"
                          :disabled="true"
            />
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <iframe type="application/pdf" width="100%" height="1000px" style="border: none">
          {{ $t('mailPage.iframeBrowserUpdate') }}
        </iframe>
      </v-card-text>

      <v-dialog v-model="sendDialog" :persistent="true" width="600px">
        <SignComponent :hash-code="sendHashCode" @cancel="onSendCancel" @sign="onSign" :disable="loading"/>
      </v-dialog>
    </template>

    <v-snackbar v-model="isSendFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      {{ $t('mailPage.messages.sendError') }}
    </v-snackbar>

    <v-snackbar v-model="isUnitNotActive"
                :timeout="5000"
                :top="true"
                color="error"
    >
      {{ $t('mailsDataTable.messages.debtError') }}
    </v-snackbar>
    <v-snackbar v-model="isContractDateExpired"
                :timeout="5000"
                :top="true"
                color="error"
    >
      {{ $t('mailsDataTable.messages.contractExpiredError') }}
    </v-snackbar>
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import MailService from '../../../services/mail.service'
import Mapper from '../../../mappers'
import SignComponent from '../../../components/SignComponent'
// import BalanceService from "@/services/balance.service";

export default {
  name: "MailPage",
  components: {
    SignComponent
  },
  data() {
    return {
      loading: false,
      mail: null,
      mailCreatedOnStr: null,

      sendDialog: false,
      sendHashCode: '',
      isSendFailed: false,
      isUnitNotActive: false,
      isContractDateExpired: false,

      pdfPath: ''
    }
  },
  methods: {
    loadMail() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const id = this.$route.params.id;
      MailService.getSingle(id)
          .then(response => {
            this.mail = Mapper.mapMail(response.data)

            this.mailCreatedOnStr = this.mail.createdOn.format('DD.MM.YYYY HH:mm:ss')
          }, () => {
            this.$router.go(-1)
          })
          .catch(() => {

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
      async onSendClicked() {
        this.loading = true;
        this.isUnitNotActive = false;
        await this.$store.dispatch(LAYOUT_LOADING_START)

        MailService.getSendHashCode(this.mail.id)
            .then(response => {
              this.sendHashCode = response.data;
              this.sendDialog = true;
            })
            .catch((err) => {
              const errorData = err.response.data;
              if (errorData.UserUnitIsActive === false) {
                this.isUnitNotActive = true;
              }
              if(errorData.OrganizationContractDateExpired === true) {
                this.isContractDateExpired = true
              }
            })
            .finally(() => {
              this.loading = false;
              this.$store.dispatch(LAYOUT_LOADING_STOP);
            });
    },
    onShowReceiptClicked() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      MailService.printPdf(this.mail.id)
          .then(() => { })
          .catch(() => { })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    clearSend() {
      this.sendDialog = false
      this.sendHashCode = ''
    },
    onSendCancel() {
      this.clearSend()
    },
    onSign(signResult) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)
      this.isSendFailed = false

      MailService.send({id: this.mail.id, signature: signResult.pkcs7})
          .then(() => {
            this.clearSend()
            this.loadMail()
            // BalanceService.get({organizationId: this.$store.getters.appLogin.organization.id})
            //   .then((data) => {
            //     this.$store.commit('setBalance', data.data);
            //   })
          }, () => {
            this.isSendFailed = true
          })
          .catch(() => {

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    this.loadMail()
  },
  watch: {
    mail(val) {
      if (val) {
        MailService.getPdfPath(val.id)
        .then(response => {
          if (response.status === 200) {
            const blob = new Blob([response.data], { type: "application/pdf" });
            const urlObject = window.URL.createObjectURL(blob);

            document.querySelector('iframe').setAttribute("src", urlObject)
          }
        })
      }
    },
    "$route": function () {
      this.loadMail()
    }
  }
}
</script>

<style scoped>

</style>